var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ocean-bi::order-link::设置"),
        width: "600px",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "edit-wrap" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "80px",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ocean-bi::order-link::时间范围") } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "value-format": "yyyy-MM-dd",
                      "start-placeholder": _vm.$t("system::common::start_date"),
                      "end-placeholder": _vm.$t("system::common::end_date"),
                    },
                    model: {
                      value: _vm.form.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "time", $$v)
                      },
                      expression: "form.time",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ocean-bi::order-link::图表类型") } },
                [
                  _c(
                    "div",
                    { staticClass: "chart-wrap" },
                    _vm._l(_vm.charts, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.key,
                          staticClass: "chart-item",
                          class: { active: _vm.form.chartType == item.key },
                          on: {
                            click: function ($event) {
                              _vm.form.chartType = item.key
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                _vm.form.chartType == item.key
                                  ? item.ableSrc
                                  : item.disableSrc,
                            },
                          }),
                          _c("p", [_vm._v(_vm._s(item.name))]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }